export const formatNumberBR = (
  value: number,
  useGrouping: boolean = false,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = 2
) =>
  new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits,
    maximumFractionDigits,
    useGrouping,
  }).format(value);